// SSP stub and loader logic
window.ssp_key = "lagence";
window.ssp_env  = 'prd';
window.ssp_lang = 'en';
window.ssp_tld  = 'sspinc.io';
window.ssp_version = 'v1';

window.ssp = window.ssp || function() {
  (window.ssp.q = window.ssp.q || []).push(arguments)
};

// Set site context immediately (before loading SSP script)
window.ssp("set", "site", {
  layout: "desktop",
  currency: "USD",
  language: "en",
  market: "US"
});

(function() {
  var a = document.createElement("script");
  a.type = "text/javascript";
  a.async = true;
  a.src = "https://" + window.ssp_key + "." + window.ssp_tld + "/" + window.ssp_version + "/ssp.js?env=" + window.ssp_env + "&lang=" + window.ssp_lang;
  var b = document.getElementsByTagName("script")[0];
  b.parentNode.insertBefore(a, b);
  window.ssp.SNIPPET_VERSION = "1.3.1";
})();

(function() {
  function createFpRoot(productId, placement = 'drawer') {
    var fpRoot = document.createElement('div');
    fpRoot.className = 'fp-root';
    fpRoot.setAttribute('data-product-id', productId);
    if (placement) {
      fpRoot.setAttribute('data-placement', placement);
    }
    return fpRoot;
  }

  function getProductIdFromQuickshopSizes(target) {
    var btn = target.querySelector('[data-product-id]');
    if (btn) {
      return btn.getAttribute('data-product-id');
    }
    if (target.getAttribute('data-product-id')) {
      return target.getAttribute('data-product-id');
    }
    return null;
  }

  function getProductInfo(target) {
    var productId = getProductIdFromQuickshopSizes(target);
    var price = target.getAttribute('data-price') || null;
    var color = target.getAttribute('data-color') || null;
    var sizes = target.getAttribute('data-sizes') ? JSON.parse(target.getAttribute('data-sizes')) : [];
    var availableSizes = target.getAttribute('data-available-sizes') ? JSON.parse(target.getAttribute('data-available-sizes')) : [];
    var salePrice = target.getAttribute('data-sale-price') || null;
    var sizeType = target.getAttribute('data-size-type') || 'regular';
    var selectedSize = target.getAttribute('data-selected-size') || null;

    return {
      productId: productId,
      sizes: sizes,
      availableSizes: availableSizes,
      price: price ? Number(price) : undefined,
      size: selectedSize,
      color: color,
      salePrice: salePrice ? Number(salePrice) : undefined,
      sizeType: sizeType
    };
  }

  function insertFpRoot() {
    var targets = document.querySelectorAll('.product__quickshop-sizes, .product__quickshop-sizes-mobile');
    targets.forEach(function(target) {
      var productId = getProductIdFromQuickshopSizes(target);
      if (!productId) return;
      var fpRoot = target.querySelector('.fp-root');
      if (fpRoot) {
        var existingProductId = fpRoot.getAttribute('data-product-id');
        if (existingProductId !== productId) {
          fpRoot.remove();
          fpRoot = null;
        } else {
          if (typeof window.ssp === 'function') {
            var productInfo = getProductInfo(target);
            window.ssp("set", "product", productInfo);
            window.ssp("start", "fitpredictor");
          }
          return;
        }
      }
      if (!fpRoot) {
        var newFpRoot = createFpRoot(productId, 'drawer');
        target.insertBefore(newFpRoot, target.firstChild);
        if (typeof window.ssp === 'function') {
          var productInfo = getProductInfo(target);
          window.ssp("set", "product", productInfo);
          window.ssp("start", "fitpredictor");
        }
      }
    });
  }

  // Initial attempt to insert fp-root
  insertFpRoot();

  // Make insertFpRoot globally available for external calls
  window.insertFpRoot = insertFpRoot;

  // Set up continuous monitoring for new quickshop content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        let shouldCheck = false;
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.classList && (node.classList.contains('product__quickshop-sizes') || node.classList.contains('product__quickshop-sizes-mobile'))) {
              shouldCheck = true;
            } else if (node.querySelector && (node.querySelector('.product__quickshop-sizes') || node.querySelector('.product__quickshop-sizes-mobile'))) {
              shouldCheck = true;
            }
          }
        });
        if (shouldCheck) {
          setTimeout(function() {
            insertFpRoot();
          }, 100);
        }
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback: periodic check for up to 30 seconds
  let attempts = 0;
  const maxAttempts = 15;
  const interval = setInterval(function() {
    insertFpRoot();
    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 2000);
})(); 